interface IArticleSettings {
  headerClass?: string
}

export const articleSettings: IArticleSettings = {}
